import type { IContactVerificationScoreItemIdSmart } from './ContactVerificationScoreItemIdSmart.interface';
import ContactVerificationScoreItemIdSmartOverview from './ContactVerificationScoreItemIdSmartOverview';

export default class ContactVerificationScoreItemIdSmart
  implements IContactVerificationScoreItemIdSmart {
  dob: string;
  name: string;
  overview: ContactVerificationScoreItemIdSmartOverview;
  reference: string;
  reportNumber: string;
  invited: boolean;

  static build = (data: IContactVerificationScoreItemIdSmart) =>
    new ContactVerificationScoreItemIdSmart(data);

  static blank = () => new ContactVerificationScoreItemIdSmart();

  /**
   * Constructor
   * @param {IContactVerificationScoreItemIdSmart} data
   */
  constructor(data?: IContactVerificationScoreItemIdSmart) {
    this.dob = data?.dob || '';
    this.name = data?.name || '';
    this.overview = new ContactVerificationScoreItemIdSmartOverview(data?.overview);
    this.reference = data?.reference || '';
    this.reportNumber = data?.reportNumber || '';
    this.invited = data?.invited || false;
  }
}
